const state = {
  dashboardtotalbydate: null,
  dashboardGraphTotal: null,
  dashboardpayouthistory: null,
  error: null,
  affiliateuser: null
};

export default state;